export function cotationReferenceLabel(row) {
  const referenceType = String(row?.reference_type || '').toLowerCase()
  const nbVentes = Number(row?.nb_ventes_reference)
  const nbAnnonces = Number(row?.nb_annonces_reference)
  if (Number.isFinite(nbAnnonces) && nbAnnonces === 0) return null
  if (referenceType === 'ventes_reelles') {
    if (Number.isFinite(nbVentes) && nbVentes > 0) {
      return `vs ventes réelles (${nbVentes} vente${nbVentes > 1 ? 's' : ''})`
    }
    return 'vs ventes réelles'
  }
  if (Number.isFinite(nbAnnonces) && nbAnnonces > 0) {
    return `vs marché affiché (${nbAnnonces} annonce${nbAnnonces > 1 ? 's' : ''})`
  }
  return null
}
